import { useEffect, useState } from 'react';
import _ from 'lodash';

import { AgeGroups } from '../../components/AgeGroups/AgeGroups';
import { PostList } from '../../components/PostList/PostList';
import { Categories } from '../../components/Categories/Categories';
import { Search } from '../../components/Search/Search';
import { ELayouts } from '../../Types/Layouts';
import { ArchiveContext } from '../../context/archive.context';
import { Box, CircularProgress, ClickAwayListener, Paper } from '@material-ui/core';
import { useApiRes } from '../../utils/useApiRes';
import { EResourcesState } from '../../Types/ResourcesState';
import { useLocation } from 'react-router-dom';

export const Archive = () => {
    const { search } = useLocation();

    let ageGroupId = null;
    let searchQuery = null;

    if (search.length) {
        const [type, value] = search.split('=');

        if (type.includes('ageGroupId')) ageGroupId = parseInt(value);
        else searchQuery = value;
    }

    const [layout, setLayout] = useState(() => {
        if (searchQuery) return ELayouts.SEARCHBAR;
        else return ELayouts.CATEGORIES;
    });

    const {
        lang,
        state,
        posts,
        data: newData,
        discoverMore,
        selectQueryParams,
        fetchNextPage,
        disabledButton,
    } = useApiRes(+ageGroupId);

    function toggleLayout() {
        const newLayout = layout == ELayouts.CATEGORIES ? ELayouts.SEARCHBAR : ELayouts.CATEGORIES;
        setLayout(newLayout);
    }

    if (state === EResourcesState.Created || state === EResourcesState.Pending)
        return (
            <Box display={'flex'} justifyContent={'center'} py={5}>
                <CircularProgress style={{ color: '#ffb300' }} size={80} />
            </Box>
        );
    if (state !== EResourcesState.Ready) return <></>;

    return (
        <ArchiveContext.Provider
            value={{
                toggleLayout,
                selectQueryParams,
                lang,
                prTypes: newData.prTypes,
                categories: newData.categories,
                tags: newData.tags,
                ageGroups: newData.ageGroups,
                selectedAgeGroupId: ageGroupId,
                homeSearchQuery: searchQuery,
            }}
        >
            <div className='Archive'>
                <div className='main-container'>
                    <AgeGroups />

                    {layout === ELayouts.CATEGORIES ? (
                        <>
                            <Categories />

                            <PostList posts={posts} fetchNextPage={fetchNextPage} discoverMore={discoverMore} disabledButton={disabledButton} />
                        </>
                    ) : (
                        <ClickAwayListener onClickAway={toggleLayout}>
                            <Paper className='paper-second-layout'>
                                <Search />
                            </Paper>
                        </ClickAwayListener>
                    )}
                </div>
            </div>
        </ArchiveContext.Provider>
    );
};
